<template>
  <div>
  <!-- {{sCrtType}} -->
    <van-grid column-num="2" clickable :border="false" :center="false">
      <van-grid-item v-for="mi in sCrtType.options" :key="mi.ItemName" @click="cmdMI(mi)">
        <div style="text-align: center">
          <ImgItem :src="mi.ImgFile" :qty="getItemQty(mi)" />
          <div>{{ mi.DispName }}</div>
          <div class="C1">${{ mi.Price1 }}</div>
          <div v-if="gGetDcText(mi)">
            <span class="tag">{{ gGetDcText(mi) }}</span>
          </div>
        </div>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<style scoped>
.van-image {
  width: 6rem;
  height: 6rem;
  border-radius: 3rem;
}
</style>

<script>
import ImgItem from "./ImgItem.vue";
export default {
  components: {
    ImgItem,
  },
  props: {
    bkmenu: Object,
    ordertmp: Array,
    list: Array,
    n: String,
  },
  data() {
    return {};
  },
  methods: {
    getItemQty(item) {
      var array = this.ordertmp.filter(
        (r) => r.TypeNo == item.TypeNo && r.ItemName == item.ItemName
      );
      return this.gSum(array, "Qty");
    },
    cmdMI(obj) {
      this.$emit("click", obj);
    },
  },
};
</script>
